module.exports = __webpack_public_path__ + "media/images/ustensiles de cuisine de base-179a15dc03930b2c97c71fb5019a4934.svg";